commusoftCommon.filter('compressCommas', function() {
    return function (value) {
        var find = ', ,';
        while(value.indexOf(find) != -1) {
            value = value.replace(new RegExp(find, 'g'), ',');
        }
        return value;
    };
});